import CustomerForm from './CustomerForm'

export default CustomerForm



// WEBPACK FOOTER //
// ./src/components/Customers/Form/index.js